module.exports = __webpack_public_path__ + "img/05.cd0d5359.png";